import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {animateShow} from "../../animations/showHideAnimation";
import {AutoCadService} from "../../services/CADService/auto-cad.service";

@Component({
  selector: 'app-auto-cad-save',
  templateUrl: './auto-cad-save.component.html',
  styleUrls: ['./auto-cad-save.component.scss'],
  animations: [animateShow]
})
export class AutoCadSaveComponent{
  public isVisible = false;
  public isUploading = false;

  constructor(private cad: AutoCadService, private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.cad.markersSynchronized.subscribe(()=>{
      this.isVisible = true;
      this.cd.detectChanges();
    });
  //  todo: add progress bar subscribe
  }

  saveCad(){
    this.isUploading = true;
    this.cd.detectChanges();
    this.cad.saveCadToServer().subscribe((result)=>{
      this.isUploading = false;
      this.isVisible = false;
      this.cd.detectChanges();
    });
  }

}
